export const GENRE_OPTIONS = [
  'Rock',
  'Pop',
  'Jazz',
  'Blues',
  'Classical',
  'Hip-Hop',
  'Electronic',
  'Metal',
  'Folk',
  'Reggae',
  'Country',
  'Funk',
  'Soul',
  'R&B',
];

export const toggleGenreSelection = (selected: string[], genre: string, max: number): string[] => {
  const normalized = Array.isArray(selected) ? selected : [];
  if (normalized.includes(genre)) {
    return normalized.filter((item) => item !== genre);
  }
  if (normalized.length >= max) {
    return normalized;
  }
  return [...normalized, genre];
};
